import type { SerpSizeConfig } from './types';

export const DEFAULT_CONFIG: SerpSizeConfig = {
  titleLimitPx: 600,
  titleFont: '400 22px "Google Sans"',
  descCharCap: 150,
  ellipsis: ' ...',
  tightTitlePx: 30,
  tightDescPx: 20,
  lowShownPct: 70,
  overflowTolerancePct: 0.5,
  defaultProfiles: [],
  connectors: ['to', 'for', 'and', 'or', 'of', 'with', '&', '|', '–', '—', '-', ':'],
  boldStopwords: ['a', 'an', 'the', 'of', 'to', 'in', 'on', 'for', 'and', 'or', 'with', 'by', 'at', 'is'],
};

const NUMERIC_KEYS = ['titleLimitPx', 'descCharCap', 'tightTitlePx', 'tightDescPx', 'lowShownPct', 'overflowTolerancePct'] as const;

/** Merge a partial config over the defaults, validating known keys. Unknown keys are ignored. */
export function resolveConfig(partial: Partial<SerpSizeConfig> & Record<string, unknown> = {}): SerpSizeConfig {
  const out: SerpSizeConfig = { ...DEFAULT_CONFIG };
  for (const key of Object.keys(DEFAULT_CONFIG) as (keyof SerpSizeConfig)[]) {
    const v = partial[key];
    if (v === undefined) continue;
    (out as unknown as Record<string, unknown>)[key] = v;
  }
  for (const k of NUMERIC_KEYS) {
    if (typeof out[k] !== 'number' || !Number.isFinite(out[k]) || out[k] < 0) {
      throw new Error(`config.${k} must be a non-negative number`);
    }
  }
  for (const k of ['defaultProfiles', 'connectors', 'boldStopwords'] as const) {
    if (!Array.isArray(out[k]) || out[k].some(x => typeof x !== 'string')) throw new Error(`config.${k} must be an array of strings`);
  }
  if (typeof out.ellipsis !== 'string') throw new Error('config.ellipsis must be a string');
  if (typeof out.titleFont !== 'string' || !/\d(\.\d+)?px/.test(out.titleFont)) throw new Error('config.titleFont must be a canvas font with a px size');
  return out;
}
